export const Expertise = [
  {
    category: "Sprachen",
    skills: [
      { icon: "language", name: "Englisch", level: "Gute Kenntnisse" },
      { icon: "language", name: "Deutsch", level: "Mittlere Kenntnisse" },
      { icon: "language", name: "Russisch", level: "Muttersprache" },
      { icon: "language", name: "Hebräisch", level: "Mittlere Kenntnisse" },
    ],
  },
  {
    category: "Fachlich",
    skills: [
      { icon: "scale", name: "Finanzmanagement" },
      { icon: "chart", name: "Reporting & Analyse" },
      { icon: "repeat", name: "Prozessautomatisierung" },
      { icon: "check", name: "Datenvalidierung" },
      { icon: "document", name: "Regulatorisches Reporting" },
      { icon: "globe", name: "Internationale Rechnungslegung" },
    ],
  },
  {
    category: "Technisch",
    skills: [
      { icon: "briefcase", name: "Microsoft Office" },
      { icon: "pie", name: "Microsoft Power BI" },
      { icon: "zap", name: "Microsoft Power Automate" },
      { icon: "layers", name: "Microsoft Power Platform" },
      { icon: "database", name: "SAP S/4HANA & Fiori" },
      { icon: "terminal", name: "SQL" },
      { icon: "video", name: "Camtasia" },
    ],
  },
  {
    category: "Allgemein",
    skills: [
      {
        icon: "activity",
        name: "Fähigkeit, grosse Mengen an Informationen schnell aufzunehmen und zu analysieren",
      },
      { icon: "search", name: "Ausgeprägte Detailgenauigkeit und Problemlösungsfähigkeiten" },
      { icon: "bulb", name: "Analytisches Denken" },
      { icon: "sitemap", name: "Strukturierte Arbeitsweise" },
      { icon: "users", name: "Interkulturelle Zusammenarbeit" },
    ],
  },
];
